import { render } from "./feedback.vue?vue&type=template&id=3f5d2f56&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=3f5d2f56&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5d2f56"]])

export default __exports__